var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenchmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9116_24106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 0H0V62H62V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9116_24106)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9116_24106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 0H0V62H62V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9116_24106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7821 8.93562L41.2511 18.4666V24.2289L50.7821 14.7101V8.93562ZM50.7821 17.2387L41.2511 26.7697V32.5321L50.7821 23.0133V17.2387ZM50.7821 25.554L41.2511 35.085V40.8474L50.7821 31.3285V25.554ZM50.7821 33.8572L41.2511 43.3882V49.1505L50.7821 39.6317V33.8572ZM50.7821 42.1603L42.1629 50.7795H50.7821V42.1603ZM41.2511 15.9137L49.5177 7.65913H41.2511V15.9137ZM50.7821 5.87207C51.7668 5.87207 52.5813 6.67444 52.5813 7.6713V50.7917C52.5813 51.7764 51.7668 52.5909 50.7821 52.5909H41.2511C40.2664 52.5909 39.4519 51.7886 39.4519 50.7917V7.6713C39.4519 6.68659 40.2664 5.87207 41.2511 5.87207H50.7821ZM35.7076 22.0407C35.7076 21.056 34.8931 20.2415 33.9084 20.2415H26.2496C25.2649 20.2415 24.4503 21.0439 24.4503 22.0407V50.7795C24.4503 51.7642 25.2649 52.5788 26.2496 52.5788H33.9084C34.8931 52.5788 35.7076 51.7764 35.7076 50.7795V22.0407ZM9.46094 50.7795V36.4101C9.46094 35.4254 10.2754 34.6109 11.2601 34.6109H18.9189C19.9036 34.6109 20.7181 35.4133 20.7181 36.4101V50.7795C20.7181 51.7642 19.9036 52.5788 18.9189 52.5788H11.2601C10.2754 52.5788 9.46094 51.7764 9.46094 50.7795Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchmark);
export default __webpack_public_path__ + "static/media/benchmark.a1374162ccba9f43da6608ddf1bf3235.svg";
export { ForwardRef as ReactComponent };